import { orientationOptions } from "@/data/options/orientationOptions";

export const orientationsMap = orientationOptions.reduce((acc: any, item: any) => {
  const { value, ...rest } = item;
  acc[value] = rest;
  return acc;
}, {})